// import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// import { useEffect } from 'react'
// import { useSelector } from 'react-redux'
// import { appApiAxios } from 'shared/axios-settings'
// import { handleRequestError } from 'shared/utils'
// import { RootState, useAppDispatch } from 'store'

// export const name = 'campaignApi'

// const initialState = {
//   data: null,
//   isLoading: true,
//   error: null,
// }

// export const getCampaignByCode = createAsyncThunk(
//   'currentSessionApi/getCurrentSessionByZoneCodes',
//   async (campaignCode: string, { rejectWithValue }) => {
//     try {
//       const res = await appApiAxios.get(`/campaign/?campaign_code=${campaignCode}`)
//       return res.data.data
//     } catch (error) {
//       return rejectWithValue(handleRequestError(error))
//     }
//   },
// )

// export const campaignSlice = createSlice({
//   name,
//   initialState,
//   reducers: {},
//   extraReducers: (builder) => {
//     builder.addCase(getCampaignByCode.pending, (state) => {
//       state.isLoading = true
//     })
//     builder.addCase(getCampaignByCode.fulfilled, (state, action) => {
//       state.data = action.payload
//       state.isLoading = false
//     })
//     builder.addCase(getCampaignByCode.rejected, (state, action) => {
//       state.error = action.payload
//       state.isLoading = false
//     })
//   },
// })

// export const useGetCampaignByCode = (cid: string) => {
//   const dispatch = useAppDispatch()
//   const { data, isLoading, error } = useSelector((state: RootState) => state.campaignApi)

//   useEffect(() => {
//     dispatch(getCampaignByCode(cid))
//   }, [])

//   return { data, isLoading, error }
// }

import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'store/axiosBaseQuery'
import { IVoteChance, IZone } from 'types'

// Define a service using a base URL and expected endpoints
export const campaignApi = createApi({
  reducerPath: 'campaginApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getCampaignByCode: builder.query<{ zones: IZone[] }, string>({
      query: (campaignCode) => ({
        url: `/campaign/?campaign_code=${campaignCode}`,
      }),
    }),
    getVoteChanceByCode: builder.query<IVoteChance, string>({
      query: (campaignCode) => ({
        url: `/chance/?campaign_code=${campaignCode}`,
      }),
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetCampaignByCodeQuery, useGetVoteChanceByCodeQuery } = campaignApi
